(() => {
  angular
    .module('app.report')
    .controller('EventsReportController', EventsReport);

  EventsReport.$inject = [
    '$q',
    '$scope',
    '$filter',
    '$window',
    '$cookies',
    'Report',
    'Targetgroup',
    'EventsService'
  ];

  function EventsReport(
    $q,
    $scope,
    $filter,
    $window,
    $cookies,
    Report,
    Targetgroup,
    EventsService
  ) {
    document.removeEventListener('visibilitychange', updateDataOnVisible);

    let isVisibilityWatcherSetted = false;
    let cache = {};

    const { report } = $scope.$parent;
    const vm = this;
    vm.hasData = report.campaign.hasData;
    vm.campaignId = $window.location.pathname.split('/')[2];
    vm.showEventsWarning = false;
    vm.profileDetailsAvailable = false;
    vm.profileEventTypes = [];
    vm.currentProfileEventType = null;
    vm.isPDF = false;
    vm.funnelEventsOrder = [
      'impression',
      'iv-supported',
      'iv-inview',
      'videostart',
      'video25pct',
      'video50pct',
      'video75pct',
      'videocomplete',
      'click',
      'signup',
      'conversion',
      'purchase',
    ];

    vm.disableWarningForSession = () => {
      vm.showEventsWarning = false;
      $cookies.putObject('showEventsWarning', false, {
        path: `/report/${vm.campaignId}`
      });
    };

    vm.getReportItem = ri => report.campaign.reportItems.find(item => item.evid === ri.evid);
    vm.isTVEnabled = reportItem => {
      const ri = vm.getReportItem(reportItem);
      return ri && ri.properties.featureTVEnabled === 1;
    };

    activate();
    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      $q.all([
        Report.getEventData(report.campaignIdParam).$promise,
        Targetgroup.catNames(report.campaignIdParam).$promise,
      ]).then((response) => {
        cache.event = response[0].data;
        cache.target = response[1].data;
        vm.loaded = true;
      }).then(() => {
        report.isCampaignLoading = false;
        report.isCampaignLoaded = true;

        if (document.visibilityState === 'visible') {
          updateDataOnVisible();
        } else {
          if (!isVisibilityWatcherSetted) {
            document.addEventListener('visibilitychange', updateDataOnVisible);
            isVisibilityWatcherSetted = true;
          }
        }
      });
    }

    function updateDataOnVisible() {
      if (document.visibilityState !== 'visible') {
        return false;
      }

      vm.target = cache.target;
      vm.eventData = cache.event;

      const eventsInOrder = events => vm.funnelEventsOrder.reduce((memo, order) => {
        const eventsFix = Array.isArray(events) ? events : [];
        const item = eventsFix.find(event => event.eventType === order);
        return item ? [...memo, item] : memo;
      }, []);

      // Enrich the by-trackpoint data (CSS class, color, disabled status..)
      if (angular.isDefined(vm.eventData) && angular.isDefined(vm.eventData.trackpoints)) {
        const availableEvents = [];
        vm.eventData.trackpoints.forEach(tp => {
          eventsInOrder(tp.events).forEach(event => {
            if (!availableEvents.find(item => item.eventType === event.eventType)) {
              availableEvents.push(event);
            }
          });
        });

        const columns = EventsService.generateEnrichedEventData(eventsInOrder(availableEvents));

        vm.eventData.trackpoints.forEach(tp => {
          columns.forEach(col => {
            tp.events = eventsInOrder(tp.events);
            if (!tp.events.find(event => event.eventType === col.eventType)) {
              tp.events.push({
                ...col,
                eventCount: 0,
              });
            }
          });
        });

        vm.eventData.details = {
          columns,
        }

        determineShowEventsWarning();
      }

      if (angular.isDefined(vm.eventData) && angular.isDefined(vm.eventData.total)) {
        vm.eventData.total.events = eventsInOrder(vm.eventData.total.events);
        // Initialize campaignEventTypes array
        vm.campaignEventTypes = [];
        _.each(vm.eventData.total.events, eventTypeTotal => {
          vm.campaignEventTypes.push(eventTypeTotal.eventType);
        });

        vm.eventComparisonData = angular.copy(vm.eventData.total.events);

        // hack for forcing update of DOM views
        vm.timelineForceUpdate = new Date().getTime();

        initEventFunnel();
      }

      // Is there profile data?
      if (angular.isDefined(vm.eventData.profile) &&
          angular.isDefined(vm.eventData.profile.age) &&
          vm.eventData.profile.age.length > 0) {
        // We grab the event types from the report items in the 'age' profile,
        // remove duplicates and sort them according to our canonical event type ordering
        // (see EventsService)
        vm.profileEventTypes = _.sortBy(_.uniq(_.map(vm.eventData.profile.age, function (reportItemAgeProfile) {
          return reportItemAgeProfile.eventType;
        })), EventsService.eventTypeSortFunction);
        // Initial event type selected
        vm.currentProfileEventType = vm.profileEventTypes[0];
        vm.profileDetailsAvailable = true;
      }
    }

    function initEventFunnel() {
      // Build funnel data (only show 4 segments, and don't show segments with 0 events)
      const maxFunnelSegments = 4;
      const allowedEvents = EventsService.generateEnrichedEventData(angular.copy(vm.eventData.total.events));
      vm.funnelSegments = [];

      vm.allowedEvents = vm.funnelEventsOrder.reduce((memo, type) => {
        const event = allowedEvents.find(item => item.eventType === type);
        return event ? [...memo, event] : memo;
      }, []);

      vm.funnelSegments = vm.allowedEvents.reduce((memo, event) => (
        (memo.length < maxFunnelSegments && event.eventCount > 0) ?
          [...memo, event] : memo
      ), []);

      // hack for forcing update of DOM views
      vm.funnelForceRedraw = new Date().getTime();
    }

    function determineShowEventsWarning() {
      if (_.isUndefined($cookies.getObject('showEventsWarning'))) {
        vm.showEventsWarning = true;
        $cookies.putObject('showEventsWarning', true, {
          path: `/report/${vm.campaignId}`
        });
      } else {
        vm.showEventsWarning = $cookies.getObject('showEventsWarning');
      }

      if (vm.showEventsWarning == true && hasEachEventTypeOnEachTrackpoint(vm.eventData)) {
        vm.showEventsWarning = false;
      }
    }

    function hasEachEventTypeOnEachTrackpoint(eventData) {
      let hasEach = true;
      angular.forEach(eventData.trackpoints, trackpoint => {
        angular.forEach(trackpoint.events, event => {
          if (_.isUndefined(event.eventCount) || event.eventCount == 0) {
            hasEach = false;
          }
        });
      });
      return hasEach;
    }

    vm.getEventSampleSizeErrorLevel = reportItem => {
      if (reportItem.sampleSize < 50) {
        return 'error';
      } else if (reportItem.sampleSize < 100) {
        return 'warning';
      }

      return null;
    };

    vm.getEventSampleSizeErrorTooltip = reportItem => {
      switch (vm.getEventSampleSizeErrorLevel(reportItem)) {
        case 'warning': return `Sample size is ${reportItem.sampleSize}. That seems a bit low!`;
        case 'error': return `Sample size is ${reportItem.sampleSize}, no profile available!`;
        default: return `Sample size is ${$filter('number')(reportItem.sampleSize)}`;
      }
    };

    vm.getEventLabelName = eventType => EventsService.getLabelName(eventType);
    vm.showProfileCategory = key => $scope[key];
    vm.hasProfileDataForEventType = eventType => _.contains(vm.profileEventTypes, eventType);

    vm.showProfileForEventType = eventType => {
      vm.currentProfileEventType = eventType;
    };

    vm.toggleProfileCategory = key => {
      $scope[key] = !$scope[key];
    };
  }
})();
